module.exports = __webpack_public_path__ + "static/img/nishikong_icon.549095c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/nishikong_icon.png
// module id = IuwD
// module chunks = 1